// In a callback.js or callback route
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const QuickbookCallback = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log('🔍 Frontend: QuickbookCallback component loaded');
    console.log('   - Current URL:', window.location.href);
    console.log('   - Current time:', new Date().toISOString());
    
    const urlParams = new URLSearchParams(window.location.search);
    const authorizationCode = urlParams.get('code');
    const state = urlParams.get('state'); // This should have the connector ID
    const realmIdFromUrl = urlParams.get('realmId');
    const realmidFromUrl = urlParams.get('realmid');
    const resolvedRealmId = realmIdFromUrl || realmidFromUrl;
    
    console.log('   - URL parameters:');
    console.log('     - code:', authorizationCode ? authorizationCode.substring(0, 20) + '...' : 'NULL');
    console.log('     - state:', state);
    console.log('     - realmId:', resolvedRealmId ? resolvedRealmId : 'NULL');
    console.log('     - All params:', Object.fromEntries(urlParams.entries()));
    
    if (authorizationCode) {
      console.log('   - Authorization code found, storing in localStorage...');
      // Store the authorization code in localStorage
      localStorage.setItem('AuthCode', authorizationCode);
      console.log('   - AuthCode stored in localStorage');

      // QuickBooks OAuth callback includes `realmId` query param, but Intuit token exchange response often does NOT.
      // Store it so the subsequent backend token exchange can persist `realmid` and validate by fetching customers.
      if (resolvedRealmId) {
        if (state) {
          localStorage.setItem(`QuickbookRealmId_${state}`, resolvedRealmId);
        }
        console.log('   - QuickbookRealmId stored in localStorage (connector scoped)');
      }
      
      // Store the connector ID if it was passed in state
      if (state) {
        console.log('   - State parameter found:', state);
        // Note: The ConnectorType should already be set before redirect
        const connectorType = localStorage.getItem('ConnectorType');
        console.log('   - ConnectorType from localStorage:', connectorType);
        
        if (connectorType) {
          const pendingConnectorKey = `Pending${connectorType}ConnectorId`;
          localStorage.setItem(pendingConnectorKey, state);
          console.log('   - Stored connector ID in localStorage with key:', pendingConnectorKey);
        } else {
          console.warn('   - No ConnectorType found in localStorage');
        }
      } else {
        console.warn('   - No state parameter found in URL');
      }
      
      console.log('   - Redirecting to /connector-token...');
      // Redirect to connector token page
      navigate('/connector-token');
    } else {
      console.error('   ❌ No authorization code found in URL');
      console.log('   - Available URL parameters:', Object.fromEntries(urlParams.entries()));
    }
  }, [navigate]);
  
  return <div>Processing Authentication...</div>;
};

export default QuickbookCallback;